import { useEffect, useState } from "react";
import { LogoGrapes } from "~/components/icons/logo-grapes";
import * as styles from "./index.module.scss";

export function ClientSideLoader({ children }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? (
    children
  ) : (
    <div className={styles.logo}>
      <LogoGrapes className={styles.logo} />
    </div>
  );
}
